<template>
  <div id="navbar-content">
    <div class="logo-wrapper">
      <!-- <img class="site-logo" src="/static/site/fulllogo.svg" /> -->
      <div class="logo-text kaushan-font">Nagy Pékség</div>
    </div>
    <div class="nav-item-wrapper custom-scrollbar">
      <div
        class="main-groups-wrapper"
        v-for="(item, index) in menuItems.filter(x =>
          x.canAccessRole.includes(getActiveUser.role)
        )"
        :key="index"
      >
        <p class="main-groups-title">
          {{ $t(item.mainGroup) }}
        </p>
        <div class="menu-item-wrapper">
          <router-link
            v-for="(component, index) in item.components.filter(x =>
              x.canAccessRole.includes(getActiveUser.role)
            )"
            :key="index"
            tag="div"
            class="menu-item"
            :to="component.path"
            :active-class="'active-link'"
            exact
          >
            <img
              class="menu-icon"
              :src="`/static/icons/navmenu/${component.icon}.svg`"
            />
            <p class="menu-component-tilte">
              {{ $t(component.name) }}
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navMenuItems from "@/assets/js/navMenuItems.js";
import { mapGetters } from "vuex";

export default {
  name: "NavbarContent",
  data() {
    return {
      menuItems: navMenuItems.menu
    };
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth",
      getActiveUser: "user/getActiveUser"
    })
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#navbar-content {
  .logo-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
    .site-logo {
      width: 90%;
      height: 70px;
    }
    .logo-text {
      font-size: 40px;
      font-weight: 650;
      text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
      margin-left: -10px;
      margin-bottom: 10px;
      color: $color-primary;
    }
  }
  .nav-item-wrapper {
    overflow-y: auto;
    height: calc(100vh - 70px);
    .main-groups-wrapper {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      padding-left: 10px;
      .main-groups-title {
        min-width: 100%;
        font-size: 14px;
        // padding-left: 10px;
        color: #505050c2;
      }
      .menu-item-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        // padding-left: 10px;
        padding-right: 20px;
        .menu-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 5px;
          min-height: 40px;
          padding-left: 10px;
          cursor: pointer;
          border-radius: 8px;
          .menu-icon {
            height: 19px;
            width: 19px;
            margin-right: 10px;
            color: $color-primary;
            filter: invert(0);
          }
          .menu-component-tilte {
            font-style: italic;
            font-size: 14px;
            line-height: 16px;
            margin: 0 !important;
            background-color: transparent;
          }
          &:hover {
            background: hsla(0, 0%, 78.4%, 0.2);
          }
        }
        .active-link {
          color: white;
          background-color: $color-primary;
          box-shadow: 0 12px 20px -10px rgba($color-primary, 0.4),
            0 4px 20px 0 rgba(0, 0, 0, 0.12),
            0 7px 8px -5px rgba($color-primary, 0.2);
          &:hover {
            background: $color-primary;
          }
          .menu-icon {
            filter: invert(1) !important;
          }
        }
      }
    }
  }
}
</style>
